import {createBrowserRouter, RouterProvider} from 'react-router'

import {AppRoutes} from './App'

export const Router = () => {
  const router = createBrowserRouter([...AppRoutes])

  return <RouterProvider router={router} />
}
